module.exports = __webpack_public_path__ + "img/P4-0-3.3902bca7.svg";